import axios from 'axios';

export default axios.create({
  baseURL:
    process.env.NODE_ENV === 'development'
      ? 'https://app-hyuko21.cloud.okteto.net/v1/'
      : 'https://api.petlog.me/v1/',
});
